import { Typography } from '@mui/material';
import SettingsContent from 'components/pageElements/InspectionPage/SettingsContent';
import PageRangeOptions from 'components/pageElements/InspectionPage/PageRangeOptions';
import { useSelector } from 'react-redux';
import { getIsSingleFile } from 'store';
import OptionalContent from 'components/pageElements/InspectionPage/OptionalContent';
import SingleFileOptionalContent from 'components/pageElements/InspectionPage/SingleFileOptionalContent';
import styles from './GVInspectionPanel.module.css';

const GVInspectionPanel = () => {
  const isSingleFile = useSelector(getIsSingleFile);

  return (
    <div className={styles.column}>
      <div className={styles.panel}>
        <Typography variant="body1" className={styles.header}>
          What would you like to inspect?
        </Typography>
        <SettingsContent />
      </div>
      <div className={styles.panel}>
        <Typography variant="body1" className={styles.header}>
          Layer & Separation Controls
        </Typography>
        {isSingleFile ? <SingleFileOptionalContent /> : <OptionalContent />}
      </div>
      <div className={styles.panel}>
        <Typography variant="body1" className={styles.header}>
          Page Selection
        </Typography>
        <PageRangeOptions />
      </div>
    </div>
  );
};

export default GVInspectionPanel;
